import JsonLd from 'components/JsonLd';
import { ORGANIZATION_NAME } from 'const/organization';

/**
 * article — объект из ArticleDetailSerializer:
 *   title, slug, cover_image, short_description,
 *   published_at, author_name, seo (с полями SeoMixin)
 */
const ArticleJsonLd = ({ article }) => {
  const canonicalUrl = article.seo?.canonical_url
    || `${window.location.origin}/articles/${article.slug}/`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.seo?.h1 || article.title,
    "description": article.seo?.seo_description || article.short_description || '',
    "image": article.cover_image ? [article.cover_image] : [],
    "datePublished": article.published_at,
    "author": {
      "@type": "Organization",
      "name": article.author_name || ORGANIZATION_NAME
    },
    "publisher": {
      "@type": "Organization",
      "name": ORGANIZATION_NAME,
      "url": window.location.origin
    },
    "url": canonicalUrl
  };

  return <JsonLd data={schema} />;
};

export default ArticleJsonLd;
